export { PerformanceTimingLogger } from './src/index';
